module.exports = "<div>\r\n    <div class=\"loadingBox\">\r\n        <div class=\"Loading_box\"> <img src=\"/public/images/loading_bg.svg\" />\r\n            <div>\r\n                <ul class=\"loading_text_Box\">\r\n                    <li class=\"loading_text\">页面加载中，请稍后...</li>\r\n                    <li class=\"loading_text_en\">Page loading, please wait...</li>\r\n                </ul>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/component/sso/template/SSOLogin.html
// module id = 147
// module chunks = 0